import * as React from 'react';

function LandingPage() {
  const styles = {
    landingPage: {
      fontFamily: 'Arial, sans-serif',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      color: '#333',
    },
    header: {
      textAlign: 'center' as const,
      marginBottom: '40px',
    },
    h1: {
      fontSize: '2.5em',
      color: '#1a5f7a',
    },
    h2: {
      fontSize: '1.8em',
      color: '#457b9d',
    },
    h3: {
      fontSize: '1.5em',
      color: '#1d3557',
    },
    section: {
      marginBottom: '40px',
    },
    featureGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '20px',
    },
    feature: {
      backgroundColor: '#f1faee',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
    ctaButton: {
      backgroundColor: '#e63946',
      color: 'white',
      padding: '15px 30px',
      fontSize: '1.2em',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      transition: 'background-color 0.3s',
    },
  };

  return (
    <div style={styles.landingPage}>
      <header style={styles.header}>
        <h1 style={styles.h1}>Your Financial Compass: Navigate with Confidence</h1>
        <h2 style={styles.h2}>Unleash the Power of AI to Demystify Investing and Propel Your Portfolio to New Heights</h2>
      </header>

      <section style={styles.section}>
        <p>In the complexity of stock market investing, Decode Investing emerges as the beacon of clarity and insight. Harnessing advanced AI and analytics, we transform the overwhelming task of stock analysis into a streamlined journey toward making empowered investment decisions.</p>
      </section>

      <section style={styles.section}>
        <h3 style={styles.h3}>Lost in Data? Find Your Investment Compass</h3>
        <p>Navigating the stock market feels like being lost in a data jungle. Understanding which stocks to buy or tracking the ones you own requires decoding a maze of complex information—business models, industry news, financial statements, and more. It's a daunting task that demands endless hours, making you wish for a compass in this wilderness.</p>
        <ul>
          <li>Mountains of text to analyze: earnings calls, SEC filings, press releases</li>
          <li>Finding actionable insights feels like searching for a needle in an endless haystack</li>
          <li>Time pressure as hours turn into days of research</li>
          <li>The journey from data to decision is exhausting and overwhelming</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h3 style={styles.h3}>Discover a Better Way to Invest</h3>
        <p>Enter Decode Investing. Imagine a world where AI and advanced analytics clear the path, transforming the overwhelming into the understandable. With us, you gain a powerful ally that sifts through the data jungle, bringing you insights and clarity.</p>
        <p>It's time to turn the tables on investing, making informed decisions with ease and confidence. Why wander lost in data when Decode Investing can be your compass to investment success?</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>How Decode Investing Empowers You</h2>
        <div style={styles.featureGrid}>
          <div style={styles.feature}>
            <h3 style={styles.h3}>1. AI Assistants for Analyzing Stocks</h3>
            <p><strong>What it does:</strong> Leverages cutting-edge AI to analyze and interpret vast amounts of financial data, providing personalized stock recommendations.</p>
            <p><strong>Your benefit:</strong> Save countless hours of research, with insights delivered directly to you. Focus on decision-making, not data sifting.</p>
          </div>
          <div style={styles.feature}>
            <h3 style={styles.h3}>2. Leaderboard: High-Performance Companies at a Glance</h3>
            <p><strong>What it does:</strong> Provides a curated list of companies ranked by profitability, financial health, and shareholder returns, updated in real time.</p>
            <p><strong>Your benefit:</strong> Instantly identify top-performing stocks, making it easier to pinpoint investment opportunities with high return potential.</p>
          </div>
          <div style={styles.feature}>
            <h3 style={styles.h3}>3. Automated Stock Fundamental Analysis</h3>
            <p><strong>What it does:</strong> Utilizes principles from world-renowned investors like Warren Buffet and Charlie Munger, automated for today's market.</p>
            <p><strong>Your benefit:</strong> Apply time-tested investment wisdom to assess stocks, ensuring your portfolio is built on solid fundamentals for enhanced long-term growth prospects.</p>
          </div>
          <div style={styles.feature}>
            <h3 style={styles.h3}>4. Circle of Competence: Tailored Investment Opportunities</h3>
            <p><strong>What it does:</strong> Finds investments in companies grouped into understandable categories, ranked by their financial performance and health.</p>
            <p><strong>Your benefit:</strong> Invest within your areas of interest or expertise, making investing more accessible and aligned with your personal or professional knowledge.</p>
          </div>
        </div>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>Transform Your Investment Journey Today</h2>
        <p>With Decode Investing, you're not just making investment decisions; you're embarking on a journey towards financial clarity and confidence. The solution to the overwhelming data deluge is here, transforming complexity into opportunity.</p>
        <p>Welcome to the future of investing, where your path to success is illuminated by intelligence and insight.</p>
        <button style={styles.ctaButton}>Get Started</button>
      </section>
    </div>
  );
};

export default LandingPage;
